import * as vp from 'vopay';
import type { PortalClientLoginResponse } from './useApi/usePostPortalClientLogin';

const { useLocalStorage } = vp.useStorage;

const useStorage = () => {
  const handlers = {
    useLoginUserNameStorage: wrapLocalStorage<string>(vp.LS_USER_LOGIN_USER_NAME),
    useSuccessStorage: () => useLocalStorage<boolean>(vp.LS_USER_LOGIN_SUCCESS),
    useAccountIDStorage: wrapLocalStorage<string>(vp.LS_USER_CLIENT_ACCOUNT_ID),
    useAccountNameStorage: wrapLocalStorage<string>(vp.LS_USER_ACCOUNT_NAME),
    useKeyStorage: wrapLocalStorage<string>(vp.LS_USER_API_KEY),
    useSignatureStorage: wrapLocalStorage<string>(vp.LS_USER_API_SIG),
    useJWTStorage: wrapLocalStorage<string>(vp.LS_USER_JWT),
    useFirebaseTokenStorage: wrapLocalStorage<string>(vp.LS_USER_FIREBASE_TOKEN),
    useCountryStorage: wrapLocalStorage<string>(vp.LS_USER_COUNTRY),
    useGCMEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_GCM_ENABLED),
    useEFTCollectEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_EFT_COLLECT_ENABLED),
    useEFTSendEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_EFT_SEND_ENABLED),
    useACHFundEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_ACH_FUND_ENABLED),
    useACHWithdrawEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_ACH_WITHDRAW_ENABLED),
    useUSDEFTCollectEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_USD_EFT_COLLECT_ENABLED),
    useUSDEFTSendEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_USD_EFT_SEND_ENABLED),
    useRTRWithdrawEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_RTR_WITHDRAW_ENABLED),
    useRTPWithdrawEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_RTP_WITHDRAW_ENABLED),
    useFedwireWithdrawEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_FEDWIRE_WITHDRAW_ENABLED),
    useFedwireFundEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_FEDWIRE_FUND_ENABLED),

    useAFTEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_AFT_ENABLED),
    useInteracMoneyRequestEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_INTERAC_MONEY_REQUEST_ENABLED),
    useInboundEtransferEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_INBOUND_ETRANSFER_ENABLED),
    useInteracBulkPayoutEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_INTERAC_BULK_PAYOUT_ENABLED),
    usePortalViewOnlyStorage: () => useLocalStorage<boolean>(vp.LS_USER_PORTALVIEWONLY),
    useMoneyRequestGenerateUrlEnabledStorage: () =>
      useLocalStorage<boolean>(vp.LS_USER_MONEY_REQUEST_GENERATE_URL_ENABLED),
    useKYCLightEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_KYC_LIGHT_ENABLED),
    useSubAccountPermissionsStorage: () => useLocalStorage<boolean>(vp.LS_USER_SUB_ACCOUNT_PERMISSIONS),
    useClientAccountsEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_CLIENT_ACCOUNT_ENABLED),
    useAutoBalanceTransferEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_AUTO_BALANCE_TRANSFER_ENABLED),
    useTransactionLabelOverrideEnabledStorage: () =>
      useLocalStorage<boolean>(vp.LS_USER_TRANSACTION_LABEL_OVERRIDER_ENABLED),
    useTransactionResubmissionEnabledStorage: () =>
      useLocalStorage<boolean>(vp.LS_USER_TRANSACTION_RESUBMISSION_ENABLED),
    useIQ11StandardEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_IQ11_STANDARD_ENABLED),
    useIQ11BoostEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_IQ11_BOOST_ENABLED),
    useIQ11PlusEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_IQ11_PLUS_ENABLED),
    useIQ11AdvantageEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_IQ11_ADVANTAGE_ENABLED),
    useIQ11DataEnrichingEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_IQ11_DATA_ENRICHING_ENABLED),
    useIQ11DataEnrichingEnhancedEnabledStorage: () =>
      useLocalStorage<boolean>(vp.LS_USER_IQ11_DATA_ENRICHING_ENHANCED_ENABLED),
    useTransactionServiceDefaultStorage: wrapLocalStorage<string>(vp.LS_USER_TRANSATION_SERVICE_DEFAULT),
    usePayLinkEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_PAYLINK_ENABLED),
    useCustomFlinksCredentialsSetStorage: () => useLocalStorage<boolean>(vp.LS_USER_CUSTOM_FLINKS_CREDENTIALS_SET),
    useCustomPlaidCredentialsSetStorage: () => useLocalStorage<boolean>(vp.LS_USER_CUSTOM_PLAID_CREDENTIALS_SET),
    useCustomInveriteCredentialsSetStorage: () =>
      useLocalStorage<boolean>(vp.LS_USER_CUSTOMER_INVERITE_CREDENTIALS_SET),
    useEnablePaylinkDeclineStorage: () => useLocalStorage<boolean>(vp.LS_USER_ENABLE_PAYLINK_DECLINE),
    useCreditCardEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_CREDITCARD_ENABLED),
    useDigitalWalletsEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_DIGITAL_WALLETS_ENABLED),
    usePaypalWithdrawEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_PAYPAL_WITHDRAW_ENABLED),
    useVenmoWithdrawEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_VENMO_WITHDRAW_ENABLED),
    useZelleWithdrawEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_ZELLE_WITHDRAW_ENABLED),
    useGooglePayEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_GOOGLE_PAY_ENABLED),
    useUserManagementEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_USER_MANAGEMENT_ENABLED),
    useAccountingSoftwareIntegrationEnabledStorage: () =>
      useLocalStorage<boolean>(vp.LS_USER_ACCOUNTING_SOFTWARE_INTERGRATION_ENABLED),
    useAccountingSystemIntegrationEnabledStorage: wrapLocalStorage<string>(
      vp.LS_USER_ACCOUNTING_SYSTEM_INTERGRATION_ENABLED,
    ),
    useAccountTransferEnabled: () => useLocalStorage<boolean>(vp.LS_USER_ACCOUNT_TRANSFER_ENABLED),
    usePushToCardEnabled: () => useLocalStorage<boolean>(vp.LS_USER_PUSH_TO_CARD_ENABLED),
    useRealTimeMoneyRequestEnabled: () => useLocalStorage<boolean>(vp.LS_USER_REAL_TIME_MONEY_REQUEST_ENABLED),
    useCustomGlobalPaySharedSecret: () => useLocalStorage<boolean>(vp.LS_USER_CUSTOM_GLOBAL_PAY_SHARED_SECRET),

    useBrandingEmailEnabled: () => useLocalStorage<boolean>(vp.LS_USER_BRANDING_EMAIL_ENABLED),
    useBrandingELinxEnabled: () => useLocalStorage<boolean>(vp.LS_USER_BRANDING_ELINX_ENABLED),
    useBrandingPortalEnabled: () => useLocalStorage<boolean>(vp.LS_USER_BRANDING_PORTAL_ENABLED),
    useBrandingOnboardingEnabled: () => useLocalStorage<boolean>(vp.LS_USER_BRANDING_ONBORDING_ENABLED),
    useInteracBasicVerificationEnabled: () => useLocalStorage<boolean>(vp.LS_USER_INTERAC_BASIC_VERIFICATION_ENABLED),
    useInteracEnhancedVerificationEnabled: () =>
      useLocalStorage<boolean>(vp.LS_USER_INTERAC_ENHANCED_VERIFICATION_ENABLED),
    useMicroDepositBankAccountVerificationEnabled: () =>
      useLocalStorage<boolean>(vp.LS_USER_MICRO_DEPOSIT_BANK_ACCOUNT_VERIFICATION_ENABLED),
    useCardBasicVerificationEnabled: () => useLocalStorage<boolean>(vp.LS_USER_CARD_BASIC_VERIFICATION_ENABLED),
    useCardEnhancedVerificationEnabled: () => useLocalStorage<boolean>(vp.LS_USER_CARD_ENHANCED_VERIFICATION_ENABLED),
    useFileConversionEnabled: () => useLocalStorage<boolean>(vp.LS_USER_FILE_CONVERSION_ENABLED),
    useFileSubmissionEnabled: () => useLocalStorage<boolean>(vp.LS_USER_FILE_SUBMISSION_ENABLED),
    useTransactionApprovalWorkflowEnabled: () =>
      useLocalStorage<boolean>(vp.LS_USER_TRANSACTION_APPROVAL_WORKFLOW_ENABLED),
    useEmailDomainEnabled: () => useLocalStorage<boolean>(vp.LS_EMAIL_DOMAIN_ENABLED),
    useChatSupportEnabled: () => useLocalStorage<boolean>(vp.LS_CHAT_SUPPORT_ENABLED),
    useInteracVerificationEnabled: () => useLocalStorage<boolean>(vp.LS_INTERAC_VERIFICATION_ENABLED),
    useBillPayEnabled: () => useLocalStorage<boolean>(vp.LS_BILL_PAY_ENABLED),
    useVirtualAccountsEnabled: () => useLocalStorage<boolean>(vp.LS_VIRTUAL_ACCOUNTS_ENABLED),
    useCPortalEnabled: () => useLocalStorage<boolean>(vp.LS_CPORTAL_ENABLED),
    useAccountSummaryEnabled: () => useLocalStorage<boolean>(vp.LS_ACCOUNT_SUMMARY_ENABLED),
    useAccountAndBillingEnabled: () => useLocalStorage<boolean>(vp.LS_ACCOUNT_AND_BILLING_ENABLED),
    useFundMyAccountEnabled: () => useLocalStorage<boolean>(vp.LS_FUND_MY_ACCOUNT_ENABLED),
    useWithdrawMyAccountEnabled: () => useLocalStorage<boolean>(vp.LS_WITHDRAW_MY_ACCOUNT_ENABLED),
    useBankAccountTransferEnabled: () => useLocalStorage<boolean>(vp.LS_BANK_ACCOUNT_TRANSFER_ENABLED),
    useOperationalAccountsEnabled: () => useLocalStorage<boolean>(vp.LS_OPERATIONAL_ACCOUNTS_ENABLED),
    usePartnerBillsAccount: () => useLocalStorage<boolean>(vp.LS_PARTNER_BILLS_ACCOUNT),
    usePaymentsEnabled: () => useLocalStorage<boolean>(vp.LS_PAYMENTS_ENABLED),
    useCollectionsEnabled: () => useLocalStorage<boolean>(vp.LS_COLLECTIONS_ENABLED),
    useShowSubAccountOrgChart: () => useLocalStorage<boolean>(vp.LS_SHOW_SUB_ACCOUNT_ORG_CHART),
    usePushToCardProcessor: wrapLocalStorage<vp.PushToCardProcessor | ''>(vp.LS_PUSH_TO_CARD_PROCESSOR),
    useCreditCardProcessor: wrapLocalStorage<vp.CreditCardProcessor | ''>(vp.LS_CREDIT_CARD_PROCESSOR),
    useACHFundingProcessor: wrapLocalStorage<vp.ACHFundingProcessor | ''>(vp.LS_ACH_FUNDING_PROCESSOR),
    useACHWithdrawProcessor: wrapLocalStorage<vp.ACHWithdrawProcessor | ''>(vp.LS_ACH_WITHDRAW_PROCESSOR),
    useInteracMoneyRequestProcessor: wrapLocalStorage<vp.InteracMoneyRequestProcessor | ''>(
      vp.LS_INTERAC_MONEY_REQUEST_PROCESSOR,
    ),
    useInteracBulkPayoutProcessor: wrapLocalStorage<vp.InteracBulkPayoutProcessor | ''>(
      vp.LS_INTERAC_BULK_PAYOUT_PROCESSOR,
    ),
    useFedwireProcessor: wrapLocalStorage<vp.FedwireProcessor | ''>(vp.LS_FEDWIRE_PROCESSOR),
    useRTPProcessor: wrapLocalStorage<vp.RTPProcessor | ''>(vp.LS_RTP_PROCESSOR),
    useFednowProcessor: wrapLocalStorage<vp.FednowProcessor | ''>(vp.LS_FEDNOW_PROCESSOR),
    useAccountTypeStorage: wrapLocalStorage<vp.ClientPortalAccountType>(vp.LS_USER_ACCOUNT_TYPE),

    useDomainStorage: wrapLocalStorage<string>(vp.LS_USER_CLIENT_DOMAIN),
    useMFAEnabledStorage: () => useLocalStorage<boolean>(vp.LS_USER_MFA_ENABLED),
    usePasswordResetRequiredStorage: () => useLocalStorage<boolean>(vp.LS_USER_PASSWORD_RESET_REQUIRED),
    useAdditionalAccounts: () => useLocalStorage<{ [key: string]: string }>(vp.LS_USER_ADDITIONAL_ACCOUNTS),
    useClientPermissions: () => useLocalStorage<vp.PermissionsApiResponse>(vp.LS_USER_PERMISSIONS),
    useAutoRefresh: () => useLocalStorage<string>(vp.LS_USER_AUTOREFRESH),
    useBanner: wrapLocalStorage<string>(vp.LS_USER_BANNER),
    useNoOperationalDefaultModal: () => useLocalStorage<boolean>(vp.LS_USER_NO_OPERATIONAL_DEFAULT_MODAL),
    useParentAccountId: wrapLocalStorage<string>(vp.LS_USER_PARENT_ACCOUNT_ID),
    useParentAccountName: wrapLocalStorage<string>(vp.LS_USER_PARENT_ACCOUNT_NAME),
    useSubAccountType: wrapLocalStorage<string>(vp.LS_USER_SUB_ACCOUNT_TYPE),
    useInterestAccountEnabled: () => useLocalStorage<boolean>(vp.LS_INTEREST_ACCOUNT_ENABLED),
    useSupportTicketEnabled: () => useLocalStorage<boolean>(vp.LS_SUPPORT_TICKET_ENABLED),
  };

  const [LoginUserName, storeLoginUserName, clearLoginUserName] = handlers.useLoginUserNameStorage();
  const [Success, storeSuccess, clearSuccess] = handlers.useSuccessStorage();
  const [AccountID, storeAccountID, clearAccountID] = handlers.useAccountIDStorage();
  const [AccountName, storeAccountName, clearAccountName] = handlers.useAccountNameStorage();
  const [Key, storeKey, clearKey] = handlers.useKeyStorage();
  const [Signature, storeSignature, clearSignature] = handlers.useSignatureStorage();
  const [FirebaseToken, storeFirebaseToken, clearFirebaseToken] = handlers.useFirebaseTokenStorage();
  const [Country, storeCountry, clearCountry] = handlers.useCountryStorage();
  const [GCMEnabled, storeGCMEnabled, clearGCMEnabled] = handlers.useGCMEnabledStorage();
  const [EFTCollectEnabled, storeEFTCollectEnabled, clearEFTCollectEnabled] = handlers.useEFTCollectEnabledStorage();
  const [EFTSendEnabled, storeEFTSendEnabled, clearEFTSendEnabled] = handlers.useEFTSendEnabledStorage();
  const [ACHFundEnabled, storeACHFundEnabled, clearACHFundEnabled] = handlers.useACHFundEnabledStorage();

  const [ACHWithdrawEnabled, storeACHWithdrawEnabled, clearACHWithdrawEnabled] =
    handlers.useACHWithdrawEnabledStorage();

  const [USDEFTCollectEnabled, storeUSDEFTCollectEnabled, clearUSDEFTCollectEnabled] =
    handlers.useUSDEFTCollectEnabledStorage();

  const [USDEFTSendEnabled, storeUSDEFTSendEnabled, clearUSDEFTSendEnabled] = handlers.useUSDEFTSendEnabledStorage();

  const [RTRWithdrawEnabled, storeRTRWithdrawEnabled, clearRTRWithdrawEnabled] =
    handlers.useRTRWithdrawEnabledStorage();

  const [RTPWithdrawEnabled, storeRTPWithdrawEnabled, clearRTPWithdrawEnabled] =
    handlers.useRTPWithdrawEnabledStorage();

  const [FedwireWithdrawEnabled, storeFedwireWithdrawEnabled, clearFedwireWithdrawEnabled] =
    handlers.useFedwireWithdrawEnabledStorage();

  const [FedwireFundEnabled, storeFedwireFundEnabled, clearFedwireFundEnabled] =
    handlers.useFedwireFundEnabledStorage();

  const [AFTEnabled, storeAFTEnabled, clearAFTEnabled] = handlers.useAFTEnabledStorage();

  const [InteracMoneyRequestEnabled, storeInteracMoneyRequestEnabled, clearInteracMoneyRequestEnabled] =
    handlers.useInteracMoneyRequestEnabledStorage();

  const [InboundEtransferEnabled, storeInboundEtransferEnabled, clearInboundEtransferEnabled] =
    handlers.useInboundEtransferEnabledStorage();

  const [InteracBulkPayoutEnabled, storeInteracBulkPayoutEnabled, clearInteracBulkPayoutEnabled] =
    handlers.useInteracBulkPayoutEnabledStorage();

  const [PortalViewOnly, storePortalViewOnly, clearPortalViewOnly] = handlers.usePortalViewOnlyStorage();

  const [MoneyRequestGenerateUrlEnabled, storeMoneyRequestGenerateUrlEnabled, clearMoneyRequestGenerateUrlEnabled] =
    handlers.useMoneyRequestGenerateUrlEnabledStorage();

  const [SubAccountPermissions, storeSubAccountPermissions, clearSubAccountPermissions] =
    handlers.useSubAccountPermissionsStorage();

  const [ClientAccountsEnabled, storeClientAccountsEnabled, clearClientAccountsEnabled] =
    handlers.useClientAccountsEnabledStorage();

  const [AutoBalanceTransferEnabled, storeAutoBalanceTransferEnabled, clearAutoBalanceTransferEnabled] =
    handlers.useAutoBalanceTransferEnabledStorage();

  const [TransactionLabelOverrideEnabled, storeTransactionLabelOverrideEnabled, clearTransactionLabelOverrideEnabled] =
    handlers.useTransactionLabelOverrideEnabledStorage();

  const [TransactionResubmissionEnabled, storeTransactionResubmissionEnabled, clearTransactionResubmissionEnabled] =
    handlers.useTransactionResubmissionEnabledStorage();

  const [IQ11StandardEnabled, storeIQ11StandardEnabled, clearIQ11StandardEnabled] =
    handlers.useIQ11StandardEnabledStorage();

  const [IQ11BoostEnabled, storeIQ11BoostEnabled, clearIQ11BoostEnabled] = handlers.useIQ11BoostEnabledStorage();
  const [IQ11PlusEnabled, storeIQ11PlusEnabled, clearIQ11PlusEnabled] = handlers.useIQ11PlusEnabledStorage();

  const [IQ11AdvantageEnabled, storeIQ11AdvantageEnabled, clearIQ11AdvantageEnabled] =
    handlers.useIQ11AdvantageEnabledStorage();

  const [IQ11DataEnrichingEnabled, storeIQ11DataEnrichingEnabled, clearIQ11DataEnrichingEnabled] =
    handlers.useIQ11DataEnrichingEnabledStorage();

  const [
    IQ11DataEnrichingEnhancedEnabled,
    storeIQ11DataEnrichingEnhancedEnabled,
    clearIQ11DataEnrichingEnhancedEnabled,
  ] = handlers.useIQ11DataEnrichingEnhancedEnabledStorage();

  const [TransactionServiceDefault, storeTransactionServiceDefault, clearTransactionServiceDefault] =
    handlers.useTransactionServiceDefaultStorage();

  const [PayLinkEnabled, storePayLinkEnabled, clearPayLinkEnabled] = handlers.usePayLinkEnabledStorage();

  const [CustomFlinksCredentialsSet, storeCustomFlinksCredentialsSet, clearCustomFlinksCredentialsSet] =
    handlers.useCustomFlinksCredentialsSetStorage();

  const [CustomPlaidCredentialsSet, storeCustomPlaidCredentialsSet, clearCustomPlaidCredentialsSet] =
    handlers.useCustomPlaidCredentialsSetStorage();

  const [CustomInveriteCredentialsSet, storeCustomInveriteCredentialsSet, clearCustomInveriteCredentialsSet] =
    handlers.useCustomInveriteCredentialsSetStorage();

  const [EnablePaylinkDecline, storeEnablePaylinkDecline, clearEnablePaylinkDecline] =
    handlers.useEnablePaylinkDeclineStorage();

  const [CreditCardEnabled, storeCreditCardEnabled, clearCreditCardEnabled] = handlers.useCreditCardEnabledStorage();

  const [DigitalWalletsEnabled, storeDigitalWalletsEnabled, clearDigitalWalletsEnabled] =
    handlers.useDigitalWalletsEnabledStorage();

  const [PaypalWithdrawEnabled, storePaypalWithdrawEnabled, clearPaypalWithdrawEnabled] =
    handlers.usePaypalWithdrawEnabledStorage();

  const [VenmoWithdrawEnabled, storeVenmoWithdrawEnabled, clearVenmoWithdrawEnabled] =
    handlers.useVenmoWithdrawEnabledStorage();
  const [ZelleWithdrawEnabled, storeZelleWithdrawEnabled, clearZelleWithdrawEnabled] =
    handlers.useZelleWithdrawEnabledStorage();
  const [GooglePayEnabled, storeGooglePayEnabled, clearGooglePayEnabled] = handlers.useGooglePayEnabledStorage();

  const [UserManagementEnabled, storeUserManagementEnabled, clearUserManagementEnabled] =
    handlers.useUserManagementEnabledStorage();

  const [
    AccountingSoftwareIntegrationEnabled,
    storeAccountingSoftwareIntegrationEnabled,
    clearAccountingSoftwareIntegrationEnabled,
  ] = handlers.useAccountingSoftwareIntegrationEnabledStorage();

  const [
    AccountingSystemIntegrationEnabled,
    storeAccountingSystemIntegrationEnabled,
    clearAccountingSystemIntegrationEnabled,
  ] = handlers.useAccountingSystemIntegrationEnabledStorage();

  const [AccountTransferEnabled, storeAccountTransferEnabled, clearAccountTransferEnabled] =
    handlers.useAccountTransferEnabled();

  const [PushToCardEnabled, storePushToCardEnabled, clearPushToCardEnabled] = handlers.usePushToCardEnabled();

  const [RealTimeMoneyRequestEnabled, storeRealTimeMoneyRequestEnabled, clearRealTimeMoneyRequestEnabled] =
    handlers.useRealTimeMoneyRequestEnabled();

  const [CustomGlobalPaySharedSecret, storeCustomGlobalPaySharedSecret, clearCustomGlobalPaySharedSecret] =
    handlers.useCustomGlobalPaySharedSecret();

  const [BrandingEmailEnabled, storeBrandingEmailEnabled, clearBrandingEmailEnabled] =
    handlers.useBrandingEmailEnabled();

  const [BrandingELinxEnabled, storeBrandingELinxEnabled, clearBrandingELinxEnabled] =
    handlers.useBrandingELinxEnabled();

  const [BrandingPortalEnabled, storeBrandingPortalEnabled, clearBrandingPortalEnabled] =
    handlers.useBrandingPortalEnabled();

  const [BrandingOnboardingEnabled, storeBrandingOnboardingEnabled, clearBrandingOnboardingEnabled] =
    handlers.useBrandingOnboardingEnabled();

  const [AccountType, storeAccountType, clearAccountType] = handlers.useAccountTypeStorage();
  const [Domain, storeDomain, clearDomain] = handlers.useDomainStorage();
  const [MFAEnabled, storeMFAEnabled, clearMFAEnabled] = handlers.useMFAEnabledStorage();

  const [PasswordResetRequired, storePasswordResetRequired, clearPasswordResetRequired] =
    handlers.usePasswordResetRequiredStorage();

  const [permissions, storePermissions, clearPermissions] = handlers.useClientPermissions();

  const [AdditionalAccounts, storeAdditionalAccounts, clearAdditionalAccounts] = handlers.useAdditionalAccounts();
  const [autoRefreshValue, storeAutoRefresh, clearAutoRefresh] = handlers.useAutoRefresh();
  const [bannerValue, storeBanner, clearBanner] = handlers.useBanner();

  const [noOperationalDefaultModal, storeNoOperationalDefaultModal, clearNoOperationalDefaultModal] =
    handlers.useNoOperationalDefaultModal();

  const [
    TransactionApprovalWorkflowEnabled,
    storeTransactionApprovalWorkflowEnabled,
    clearTransactionApprovalWorkflowEnabled,
  ] = handlers.useTransactionApprovalWorkflowEnabled();

  const [ParentAccountID, storeParentAccountId, clearParentAccountId] = handlers.useParentAccountId();
  const [ParentAccountName, storeParentAccountName, clearParentAccountName] = handlers.useParentAccountName();
  const [SubAccountType, storeSubAccountType, clearSubAccountType] = handlers.useSubAccountType();

  const [emailDomainEnabled, storeEmailDomainEnabled, clearEmailDomainEnabled] = handlers.useEmailDomainEnabled();
  const [ChatSupportEnabled, storeChatSupportEnabled, clearChatSupportEnabled] = handlers.useChatSupportEnabled();

  const [InteracBasicVerificationEnabled, storeInteracBasicVerificationEnabled, clearInteracBasicVerificationEnabled] =
    handlers.useInteracBasicVerificationEnabled();

  const [
    MicroDepositBankAccountVerificationEnabled,
    storeMicroDepositBankAccountVerificationEnabled,
    clearMicroDepositBankAccountVerificationEnabled,
  ] = handlers.useMicroDepositBankAccountVerificationEnabled();

  const [CardBasicVerificationEnabled, storeCardBasicVerificationEnabled, clearCardBasicVerificationEnabled] =
    handlers.useCardBasicVerificationEnabled();

  const [CardEnhancedVerificationEnabled, storeCardEnhancedVerificationEnabled, clearCardEnhancedVerificationEnabled] =
    handlers.useCardEnhancedVerificationEnabled();

  const [FileConversionEnabled, storeFileConversionEnabled, clearFileConversionEnabled] =
    handlers.useFileConversionEnabled();

  const [FileSubmissionEnabled, storeFileSubmissionEnabled, clearFileSubmissionEnabled] =
    handlers.useFileSubmissionEnabled();

  const [
    InteracEnhancedVerificationEnabled,
    storeInteracEnhancedVerificationEnabled,
    clearInteracEnhancedVerificationEnabled,
  ] = handlers.useInteracEnhancedVerificationEnabled();

  const [InteracVerificationEnabled, storeInteracVerificationEnabled, clearInteracVerificationEnabled] =
    handlers.useInteracVerificationEnabled();

  const [BillPayEnabled, storeBillPayEnabled, clearBillPayEnabled] = handlers.useBillPayEnabled();

  const [VirtualAccountsEnabled, storeVirtualAccountsEnabled, clearVirtualAccountsEnabled] =
    handlers.useVirtualAccountsEnabled();

  const [CPortalEnabled, storeCPortalEnabled, clearCPortalEnabled] = handlers.useCPortalEnabled();

  const [AccountSummaryEnabled, storeAccountSummaryEnabled, clearAccountSummaryEnabled] =
    handlers.useAccountSummaryEnabled();

  const [AccountAndBillingEnabled, storeAccountAndBillingEnabled, clearAccountAndBillingEnabled] =
    handlers.useAccountAndBillingEnabled();

  const [FundMyAccountEnabled, storeFundMyAccountEnabled, clearFundMyAccountEnabled] =
    handlers.useFundMyAccountEnabled();

  const [WithdrawMyAccountEnabled, storeWithdrawMyAccountEnabled, clearWithdrawMyAccountEnabled] =
    handlers.useWithdrawMyAccountEnabled();

  const [BankAccountTransferEnabled, storeBankAccountTransferEnabled, clearBankAccountTransferEnabled] =
    handlers.useBankAccountTransferEnabled();

  const [OperationalAccountsEnabled, storeOperationalAccountsEnabled, clearOperationalAccountsEnabled] =
    handlers.useOperationalAccountsEnabled();

  const [PartnerBillsAccount, storePartnerBillsAccount, clearPartnerBillsAccount] = handlers.usePartnerBillsAccount();
  const [PaymentsEnabled, storePaymentsEnabled, clearPaymentsEnabled] = handlers.usePaymentsEnabled();
  const [CollectionsEnabled, storeCollectionsEnabled, clearCollectionsEnabled] = handlers.useCollectionsEnabled();

  const [ShowSubAccountOrgChart, storeShowSubAccountOrgChart, clearShowSubAccountOrgChart] =
    handlers.useShowSubAccountOrgChart();

  const [PushToCardProcessor, storePushToCardProcessor, clearPushToCardProcessor] = handlers.usePushToCardProcessor();
  const [CreditCardProcessor, storeCreditCardProcessor, clearCreditCardProcessor] = handlers.useCreditCardProcessor();
  const [ACHFundingProcessor, storeACHFundingProcessor, clearACHFundingProcessor] = handlers.useACHFundingProcessor();

  const [ACHWithdrawProcessor, storeACHWithdrawProcessor, clearACHWithdrawProcessor] =
    handlers.useACHWithdrawProcessor();

  const [InteracMoneyRequestProcessor, storeInteracMoneyRequestProcessor, clearInteracMoneyRequestProcessor] =
    handlers.useInteracMoneyRequestProcessor();

  const [InteracBulkPayoutProcessor, storeInteracBulkPayoutProcessor, clearInteracBulkPayoutProcessor] =
    handlers.useInteracBulkPayoutProcessor();

  const [FedwireProcessor, storeFedwireProcessor, clearFedwireProcessor] = handlers.useFedwireProcessor();
  const [RTPProcessor, storeRTPProcessor, clearRTPProcessor] = handlers.useRTPProcessor();
  const [FednowProcessor, storeFednowProcessor, clearFednowProcessor] = handlers.useFednowProcessor();
  const [JWToken, storeJWTToken, clearJWTToken] = handlers.useJWTStorage();
  const [KYCLightEnabled, storeKYCLightEnabled, clearKYCLightEnabled] = handlers.useKYCLightEnabledStorage();

  const [interestAccountEnabled, storeInterestAccountEnabled, clearInterestAccountEnabled] =
    handlers.useInterestAccountEnabled();

  const [SupportTicketEnabled, storeSupportTicketEnabled, clearSupportTicketEnabled] =
    handlers.useSupportTicketEnabled();

  return {
    login: {
      getClientLogin: () => ({
        Success,
        LoginUserName,
        AccountID,
        AccountName,
        Key,
        Signature,
        FirebaseToken,
        Country,
        GCMEnabled: GCMEnabled ? '1' : '0',
        EFTCollectEnabled: EFTCollectEnabled ? '1' : '0',
        EFTSendEnabled: EFTSendEnabled ? '1' : '0',
        ACHFundEnabled: ACHFundEnabled ? '1' : '0',
        ACHWithdrawEnabled: ACHWithdrawEnabled ? '1' : '0',
        USDEFTCollectEnabled: USDEFTCollectEnabled ? '1' : '0',
        USDEFTSendEnabled: USDEFTSendEnabled ? '1' : '0',
        RTRWithdrawEnabled: RTRWithdrawEnabled ? '1' : '0',
        RTPWithdrawEnabled: RTPWithdrawEnabled ? '1' : '0',
        FedwireWithdrawEnabled: FedwireWithdrawEnabled ? '1' : '0',
        FedwireFundEnabled: FedwireFundEnabled ? '1' : '0',
        AFTEnabled: !!AFTEnabled,
        InteracMoneyRequestEnabled: InteracMoneyRequestEnabled ? '1' : '0',
        InboundEtransferEnabled: InboundEtransferEnabled ? '1' : '0',
        InteracBulkPayoutEnabled: InteracBulkPayoutEnabled ? '1' : '0',
        PortalViewOnly: PortalViewOnly ? '1' : '0',
        MoneyRequestGenerateUrlEnabled: MoneyRequestGenerateUrlEnabled ? '1' : '0',
        KYCLightEnabled: KYCLightEnabled ? '1' : '0',
        SubAccountPermissions: SubAccountPermissions ? '1' : '0',
        ClientAccountsEnabled: ClientAccountsEnabled ? '1' : '0',
        AutoBalanceTransferEnabled: AutoBalanceTransferEnabled ? '1' : '0',
        TransactionLabelOverrideEnabled: TransactionLabelOverrideEnabled ? '1' : '0',
        TransactionResubmissionEnabled: TransactionResubmissionEnabled ? '1' : '0',
        IQ11StandardEnabled: IQ11StandardEnabled ? '1' : '0',
        IQ11BoostEnabled: IQ11BoostEnabled ? '1' : '0',
        IQ11PlusEnabled: IQ11PlusEnabled ? '1' : '0',
        IQ11AdvantageEnabled: IQ11AdvantageEnabled ? '1' : '0',
        IQ11DataEnrichingEnabled: Boolean(IQ11DataEnrichingEnabled),
        IQ11DataEnrichingEnhancedEnabled: Boolean(IQ11DataEnrichingEnhancedEnabled),
        TransactionServiceDefault,
        PayLinkEnabled: PayLinkEnabled ? '1' : '0',
        CustomFlinksCredentialsSet,
        CustomPlaidCredentialsSet,
        CustomInveriteCredentialsSet,
        EnablePaylinkDecline: EnablePaylinkDecline ? '1' : '0',
        CreditCardEnabled: CreditCardEnabled ? '1' : '0',

        UserManagementEnabled: UserManagementEnabled ? '1' : '0',
        AccountingSoftwareIntegrationEnabled: AccountingSoftwareIntegrationEnabled || false,
        AccountingSystemIntegrationEnabled: AccountingSystemIntegrationEnabled ? '1' : '0',
        AccountTransferEnabled: AccountTransferEnabled ? '1' : '0',
        PushToCardEnabled: PushToCardEnabled ? '1' : '0',
        RealTimeMoneyRequestEnabled: RealTimeMoneyRequestEnabled ? '1' : '0',
        BrandingEmailEnabled: BrandingEmailEnabled ? '1' : '0',
        BrandingELinxEnabled: BrandingELinxEnabled ? '1' : '0',
        BrandingPortalEnabled: BrandingPortalEnabled ? '1' : '0',
        BrandingOnboardingEnabled: BrandingOnboardingEnabled ? '1' : '0',
        TransactionApprovalWorkflowEnabled: TransactionApprovalWorkflowEnabled ? '1' : '0',
        EmailDomainEnabled: emailDomainEnabled ? '1' : '0',
        ChatSupportEnabled: !!ChatSupportEnabled,

        InteracVerificationEnabled: !!InteracVerificationEnabled,
        BillPayEnabled: !!BillPayEnabled,
        VirtualAccountsEnabled: !!VirtualAccountsEnabled,
        CPortalEnabled: !!CPortalEnabled,
        AccountSummaryEnabled: !!AccountSummaryEnabled,
        AccountAndBillingEnabled: !!AccountAndBillingEnabled,
        FundMyAccountEnabled: !!FundMyAccountEnabled,
        WithdrawMyAccountEnabled: !!WithdrawMyAccountEnabled,
        BankAccountTransferEnabled: !!BankAccountTransferEnabled,
        OperationalAccountsEnabled: !!OperationalAccountsEnabled,
        PartnerBillsAccount: !!PartnerBillsAccount,
        PaymentsEnabled: !!PaymentsEnabled,
        CollectionsEnabled: !!CollectionsEnabled,
        ShowSubAccountOrgChart: !!ShowSubAccountOrgChart,
        PushToCardProcessor,
        CreditCardProcessor,
        ACHFundingProcessor,
        ACHWithdrawProcessor,
        InteracMoneyRequestProcessor,
        InteracBulkPayoutProcessor,
        FedwireProcessor,
        RTPProcessor,
        FednowProcessor,
        InterestAccountEnabled: interestAccountEnabled ? '1' : '0',
        InteracBasicVerificationEnabled: InteracBasicVerificationEnabled ? '1' : '0',
        InteracEnhancedVerificationEnabled: InteracEnhancedVerificationEnabled ? '1' : '0',
        SupportTicketEnabled: !!SupportTicketEnabled,
        DigitalWalletsEnabled: !!DigitalWalletsEnabled,
        PaypalWithdrawEnabled: !!PaypalWithdrawEnabled,
        VenmoWithdrawEnabled: !!VenmoWithdrawEnabled,
        ZelleWithdrawEnabled: !!ZelleWithdrawEnabled,
        MicroDepositBankAccountVerificationEnabled: !!MicroDepositBankAccountVerificationEnabled,
        CardBasicVerificationEnabled: !!CardBasicVerificationEnabled,
        CardEnhancedVerificationEnabled: !!CardEnhancedVerificationEnabled,
        FileConversionEnabled: !!FileConversionEnabled,
        FileSubmissionEnabled: !!FileSubmissionEnabled,
        CustomGlobalPaySharedSecret,
        AccountType: AccountType ? AccountType : 'Standard',
        Domain,
        MFAEnabled,
        PasswordResetRequired,
        ParentAccountID,
        ParentAccountName,
        SubAccountType,
        AdditionalAccounts,
        GooglePayEnabled: !!GooglePayEnabled,
        JWT: JWToken,
      }),

      storeClientLogin: (response: PortalClientLoginResponse, LoginUsername: string) => {
        if (LoginUsername !== '') {
          storeLoginUserName(LoginUsername);
        }

        storeSuccess(response.Success);
        storeAccountName(response.AccountName);

        storeFirebaseToken(response.FirebaseToken);
        storeCountry(response.Country);
        storeGCMEnabled(response.GCMEnabled === '1');
        storeEFTCollectEnabled(response.EFTCollectEnabled === '1');
        storeEFTSendEnabled(response.EFTSendEnabled === '1');
        storeACHFundEnabled(response.ACHFundEnabled === '1');
        storeACHWithdrawEnabled(response.ACHWithdrawEnabled === '1');
        storeUSDEFTCollectEnabled(response.USDEFTCollectEnabled === '1');
        storeUSDEFTSendEnabled(response.USDEFTSendEnabled === '1');
        storeRTRWithdrawEnabled(response.RTRWithdrawEnabled === '1');
        storeRTPWithdrawEnabled(response.RTPWithdrawEnabled === '1');
        storeFedwireWithdrawEnabled(response.FedwireWithdrawEnabled === '1');
        storeFedwireFundEnabled(response.FedwireFundEnabled === '1');
        storeAFTEnabled(response.AFTEnabled);
        storeInteracMoneyRequestEnabled(response.InteracMoneyRequestEnabled === '1');
        storeInboundEtransferEnabled(response.InboundEtransferEnabled === '1');
        storeInteracBulkPayoutEnabled(response.InteracBulkPayoutEnabled === '1');
        storePortalViewOnly(response.PortalViewOnly === '1');
        storeMoneyRequestGenerateUrlEnabled(response.MoneyRequestGenerateUrlEnabled === '1');
        storeKYCLightEnabled(response.KYCLightEnabled === '1');
        storeSubAccountPermissions(response.SubAccountPermissions === '1');
        storeClientAccountsEnabled(response.ClientAccountsEnabled === '1');
        storeAutoBalanceTransferEnabled(response.AutoBalanceTransferEnabled === '1');
        storeTransactionLabelOverrideEnabled(response.TransactionLabelOverrideEnabled === '1');
        storeTransactionResubmissionEnabled(response.TransactionResubmissionEnabled === '1');
        storeIQ11StandardEnabled(response.IQ11StandardEnabled === '1');
        storeIQ11BoostEnabled(response.IQ11BoostEnabled === '1');
        storeIQ11PlusEnabled(response.IQ11PlusEnabled === '1');
        storeIQ11AdvantageEnabled(response.IQ11AdvantageEnabled === '1');
        storeIQ11DataEnrichingEnabled(response.IQ11DataEnrichingEnabled);
        storeIQ11DataEnrichingEnhancedEnabled(response.IQ11DataEnrichingEnhancedEnabled);
        storeTransactionServiceDefault(response.TransactionServiceDefault);
        storePayLinkEnabled(response.PayLinkEnabled === '1');
        storeCustomFlinksCredentialsSet(response.CustomFlinksCredentialsSet);
        storeCustomPlaidCredentialsSet(response.CustomPlaidCredentialsSet);
        storeCustomInveriteCredentialsSet(response.CustomInveriteCredentialsSet);
        storeEnablePaylinkDecline(response.EnablePaylinkDecline === '1');
        storeCreditCardEnabled(response.CreditCardEnabled === '1');
        storeDigitalWalletsEnabled(response.DigitalWalletsEnabled);
        storePaypalWithdrawEnabled(response.PaypalWithdrawEnabled);
        storeVenmoWithdrawEnabled(response.VenmoWithdrawEnabled);
        storeZelleWithdrawEnabled(response.ZelleWithdrawEnabled);

        storeUserManagementEnabled(response.UserManagementEnabled === '1');
        storeAccountingSystemIntegrationEnabled(response.AccountingSystemIntegrationEnabled);
        storeAccountingSoftwareIntegrationEnabled(response.AccountingSoftwareIntegrationEnabled);
        storeAccountTransferEnabled(response.AccountTransferEnabled === '1');
        storePushToCardEnabled(response.PushToCardEnabled === '1');
        storeRealTimeMoneyRequestEnabled(response.RealTimeMoneyRequestEnabled === '1');

        storeBrandingEmailEnabled(response.BrandingEmailEnabled === '1');
        storeBrandingELinxEnabled(response.BrandingELinxEnabled === '1');
        storeBrandingPortalEnabled(response.BrandingPortalEnabled === '1');
        storeBrandingOnboardingEnabled(response.BrandingOnboardingEnabled === '1');

        storeCustomGlobalPaySharedSecret(response.CustomGlobalPaySharedSecret);
        storeKYCLightEnabled(response.KYCLightEnabled === '1');
        storeTransactionApprovalWorkflowEnabled(response.TransactionApprovalWorkflowEnabled === '1');
        storeEmailDomainEnabled(response.EmailDomainEnabled === '1');
        storeChatSupportEnabled(response.ChatSupportEnabled);

        storeInteracVerificationEnabled(response.InteracVerificationEnabled);
        storeBillPayEnabled(response.BillPayEnabled);
        storeVirtualAccountsEnabled(response.VirtualAccountsEnabled);
        storeCPortalEnabled(response.CPortalEnabled);
        storeAccountSummaryEnabled(response.AccountSummaryEnabled);
        storeAccountAndBillingEnabled(response.AccountAndBillingEnabled);
        storeFundMyAccountEnabled(response.FundMyAccountEnabled);
        storeWithdrawMyAccountEnabled(response.WithdrawMyAccountEnabled);
        storeBankAccountTransferEnabled(response.BankAccountTransferEnabled);
        storeOperationalAccountsEnabled(response.OperationalAccountsEnabled);
        storePartnerBillsAccount(response.PartnerBillsAccount);
        storePaymentsEnabled(response.PaymentsEnabled);
        storeCollectionsEnabled(response.CollectionsEnabled);
        storeShowSubAccountOrgChart(response.ShowSubAccountOrgChart);
        storePushToCardProcessor(response.PushToCardProcessor || '');
        storeCreditCardProcessor(response.CreditCardProcessor || '');
        storeACHFundingProcessor(response.ACHFundingProcessor || '');
        storeACHWithdrawProcessor(response.ACHWithdrawProcessor || '');
        storeInteracMoneyRequestProcessor(response.InteracMoneyRequestProcessor || '');
        storeInteracBulkPayoutProcessor(response.InteracBulkPayoutProcessor || '');
        storeFedwireProcessor(response.FedwireProcessor || '');
        storeRTPProcessor(response.RTPProcessor || '');
        storeFednowProcessor(response.FednowProcessor || '');
        storeInteracBasicVerificationEnabled(response.InteracBasicVerificationEnabled === '1');
        storeInteracEnhancedVerificationEnabled(response.InteracEnhancedVerificationEnabled === '1');
        storeMicroDepositBankAccountVerificationEnabled(response.MicroDepositBankAccountVerificationEnabled);
        storeCardBasicVerificationEnabled(response.CardBasicVerificationEnabled);
        storeCardEnhancedVerificationEnabled(response.CardEnhancedVerificationEnabled);
        storeFileConversionEnabled(response.FileConversionEnabled);
        storeFileSubmissionEnabled(response.FileSubmissionEnabled);
        storeAccountType(response.AccountType);
        storeDomain(response.Domain);
        storeMFAEnabled(response.MFAEnabled);
        storePasswordResetRequired(response.PasswordResetRequired);
        storeAdditionalAccounts(response.AdditionalAccounts);
        storeParentAccountId(response.ParentAccountID);
        storeParentAccountName(response.ParentAccountName);
        storeSubAccountType(response.SubAccountType);
        storeInterestAccountEnabled(response.InterestAccountEnabled === '1');
        storeSupportTicketEnabled(response.SupportTicketEnabled);
        storePaypalWithdrawEnabled(response.PaypalWithdrawEnabled);
        storeVenmoWithdrawEnabled(response.VenmoWithdrawEnabled);
        storeZelleWithdrawEnabled(response.ZelleWithdrawEnabled);
        storeGooglePayEnabled(response.GooglePayEnabled);
      },
      storeLoginValues: (response: PortalClientLoginResponse) => {
        storeAccountID(response.AccountID);
        storeKey(response.Key);
        storeSignature(response.Signature);
        storeJWTToken(response.JWT);
      },
      storeLoginUsername: (LoginUsername: string) => {
        if (LoginUsername !== '') {
          storeLoginUserName(LoginUsername);
        }
      },
      clearClientLogin: () => {
        clearSuccess();
        clearLoginUserName();
        clearAccountID();
        clearAccountName();
        clearKey();
        clearSignature();
        clearJWTToken();
        clearFirebaseToken();
        clearCountry();
        clearGCMEnabled();
        clearTransactionApprovalWorkflowEnabled();
        clearEmailDomainEnabled();
        clearChatSupportEnabled();
        clearMicroDepositBankAccountVerificationEnabled();
        clearInteracVerificationEnabled();
        clearBillPayEnabled();
        clearVirtualAccountsEnabled();
        clearCPortalEnabled();
        clearAccountSummaryEnabled();
        clearAccountAndBillingEnabled();
        clearFundMyAccountEnabled();
        clearWithdrawMyAccountEnabled();
        clearBankAccountTransferEnabled();
        clearOperationalAccountsEnabled();
        clearPartnerBillsAccount();
        clearPaymentsEnabled();
        clearCollectionsEnabled();
        clearShowSubAccountOrgChart();
        clearPushToCardProcessor();
        clearCreditCardProcessor();
        clearACHFundingProcessor();
        clearACHWithdrawProcessor();
        clearInteracMoneyRequestProcessor();
        clearInteracBulkPayoutProcessor();
        clearFedwireProcessor();
        clearRTPProcessor();
        clearFednowProcessor();
        clearInteracBasicVerificationEnabled();
        clearMicroDepositBankAccountVerificationEnabled();
        clearCardBasicVerificationEnabled();
        clearCardEnhancedVerificationEnabled();
        clearFileConversionEnabled();
        clearFileSubmissionEnabled();
        clearInteracEnhancedVerificationEnabled();
        clearInterestAccountEnabled();
        clearSupportTicketEnabled();
        clearEFTCollectEnabled();
        clearEFTSendEnabled();
        clearACHFundEnabled();
        clearACHWithdrawEnabled();
        clearUSDEFTCollectEnabled();
        clearUSDEFTSendEnabled();
        clearRTRWithdrawEnabled();
        clearRTPWithdrawEnabled();
        clearFedwireWithdrawEnabled();
        clearFedwireFundEnabled();
        clearAFTEnabled();
        clearInteracMoneyRequestEnabled();
        clearInboundEtransferEnabled();
        clearInteracBulkPayoutEnabled();
        clearPortalViewOnly();
        clearMoneyRequestGenerateUrlEnabled();
        clearKYCLightEnabled();
        clearSubAccountPermissions();
        clearClientAccountsEnabled();
        clearAutoBalanceTransferEnabled();
        clearTransactionLabelOverrideEnabled();
        clearTransactionResubmissionEnabled();
        clearIQ11StandardEnabled();
        clearIQ11BoostEnabled();
        clearIQ11PlusEnabled();
        clearIQ11AdvantageEnabled();
        clearIQ11DataEnrichingEnabled();
        clearIQ11DataEnrichingEnhancedEnabled();
        clearTransactionServiceDefault();
        clearPayLinkEnabled();
        clearCustomFlinksCredentialsSet();
        clearCustomPlaidCredentialsSet();
        clearCustomInveriteCredentialsSet();
        clearEnablePaylinkDecline();
        clearCreditCardEnabled();
        clearDigitalWalletsEnabled();
        clearPaypalWithdrawEnabled();
        clearVenmoWithdrawEnabled();
        clearZelleWithdrawEnabled();
        clearGooglePayEnabled();
        clearUserManagementEnabled();
        clearAccountingSoftwareIntegrationEnabled();
        clearAccountingSystemIntegrationEnabled();
        clearAccountTransferEnabled();
        clearRealTimeMoneyRequestEnabled();
        clearPushToCardEnabled();
        clearCustomGlobalPaySharedSecret();
        clearAccountType();
        clearDomain();
        clearMFAEnabled();
        clearPasswordResetRequired();
        clearAdditionalAccounts();
        clearBrandingEmailEnabled();
        clearBrandingELinxEnabled();
        clearBrandingPortalEnabled();
        clearBrandingOnboardingEnabled();
        clearKYCLightEnabled();
        clearParentAccountId();
        clearParentAccountName();
        clearSubAccountType();
      },
    },
    permissions: {
      getClientPermissions: () => permissions,
      storePermissions: (perms: vp.PermissionsApiResponse) => storePermissions(perms),
      clearPermissions,
    },
    autoRefresh: {
      getAutoRefresh: () => autoRefreshValue,
      storeAutoRefresh: (response: string) => storeAutoRefresh(response),
      clearAutoRefresh,
    },
    NoOperationalDefault: {
      noOperationalDefaultModal,
      storeNoOperationalDefaultModal: (response: boolean) => {
        storeNoOperationalDefaultModal(response);
      },

      clearNoOperationalDefaultModal,
    },
    banner: {
      getBanner: () => bannerValue,
      storeBanner: (response: '0' | '1') => {
        storeBanner(response);
      },
      clearBanner: () => {
        clearBanner();
      },
    },
  };
};

function wrapLocalStorage<T extends string>(key: string): () => [T | '', (input: T) => void, () => void] {
  return () => {
    const [value, setValue, clearValue] = useLocalStorage<T | ''>(key, '');

    return [value || '', (v: T) => setValue(v), () => clearValue()];
  };
}

export default useStorage;
